import React, { useEffect, useState } from 'react'
import { Box, Flex, Text, Button } from 'pcln-design-system'
import styled from 'styled-components'
import { Carousel } from 'pcln-carousel'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import ProductItem from './ProductItem'
import PRODUCT_DATA from './content'
import LayoutComponentWrapper from '../LayoutComponentWrapper'

const StyledFlex = styled(Flex)`
  rowgap: 32px;
  gap: 16px;
`

export default function ProductRelease() {
  const [isBrowser, setIsBrowser] = useState(false)
  useEffect(() => {
    setIsBrowser(true)
  }, [])
  return (
    <LayoutComponentWrapper>
      <StyledFlex flexDirection={['column', null, null, null, 'row']}>
        <Box
          width={[1, null, null, null, 1 / 4]}
          margin="auto"
          textAlign="center"
        >
          <Text
            textStyle={['heading3', null, 'heading2']}
            color="text.heading"
            pb={1}
          >
            Priceline’s 2023 Summer Release:
          </Text>
          <Text textStyle="article" pb={[3, null, 4]}>
            Introducing Our Trip Intelligence Suite
          </Text>
          <Button
            width={[3 / 4, null, null, null, 1]}
            onClick={() => {
              analytics.fireEvent({
                action: 'product release',
                category: ANALYTICS_CATEGORY_HOME,
                label: 'product release click'
              })
              window.open('/partner/v2/summer-release-2023 ')
            }}
          >
            Learn More
          </Button>
        </Box>
        <Flex width={['100%', null, null, null, 3 / 4]} style={{ gap: '16px' }}>
          {isBrowser && (
            <Carousel
              arrowsPosition="hide"
              onSlideChange={() => {
                // do  nothing
              }}
              visibleSlides={[2.5, 3, 3]}
              mobileVisibleSlides={[1.5, 2.5]}
            >
              {PRODUCT_DATA.map(data => {
                return <ProductItem {...data} key={data.headline} />
              })}
            </Carousel>
          )}
        </Flex>
      </StyledFlex>
    </LayoutComponentWrapper>
  )
}
